<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span>{{ info.extOrgName }} 提供课程详情</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form ref="form" :inline="true" :model="form" label-width="90px">
        <el-form-item label="">
          <el-select
            v-model="form.schoolYearSemester"
            clearable
            placeholder="请选择学年学期"
          >
            <el-option
              v-for="item in semesterList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
    <el-form-item label="">
          <el-select
            v-model="form.campus"
            clearable
            placeholder="选择校区"
            class="label"
          >
            <el-option
              v-for="item in campusList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="form.gradeId"
            clearable
            @clear="searchFun()"
            placeholder="选择年级"
            class="label"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="form.courseName"
            clearable
            placeholder="请输入课程名称"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="getDataList"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 校内教师 -->
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="courseName" label="课程名称" align="center">
          </el-table-column>
          <el-table-column prop="teacherName" label="授课老师" align="center">
          </el-table-column>
          <el-table-column prop="gradeName" label="招生年级" align="center">
          </el-table-column>
          <el-table-column prop="classNum" label="课时总数" align="center">
          </el-table-column>
          <el-table-column prop="classTime" label="上课时间" align="center">
          </el-table-column>
          <el-table-column prop="locationName" label="上课地点" align="center">
          </el-table-column>
          <el-table-column prop="totalLimit" label="招生人数" align="center">
          </el-table-column>
          <el-table-column prop="selectedCount" label="报名人数" align="center">
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--分页组件-->
          <el-pagination
            background
            :current-page="page.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            :total="page.totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/wisdomSchool/index";
export default {
  props: {
    info: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      form: {
        campus: "",
        schoolYearSemester: "",
        gradeId: "",
        courseName: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList"))||[],
      semesterList: [
        {id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
      ],
      tableData: [
        {courseName:'海滨少儿美术',teacherName:'方诗雅',gradeName:'一年级二年级',classNum:'46',classTime:'每周四15:30-16:10',locationName:'美术教室1',totalLimit:'50',selectedCount:'43'},
        {courseName:'幸福劳动课',teacherName:'吴博俊',gradeName:'二年级三年级',classNum:'26',classTime:'每周四15:30-16:10',locationName:'三年级1班',totalLimit:'50',selectedCount:'43'},
        {courseName:'世界百科课',teacherName:'喻环韵',gradeName:'三年级四年级',classNum:'56',classTime:'每周五17:10-17:50',locationName:'三年级1班',totalLimit:'50',selectedCount:'43'},
        {courseName:'美学鉴赏课',teacherName:'曾歌菁',gradeName:'一年级二年级',classNum:'36',classTime:'每周一15:30-16:10',locationName:'四年级1班',totalLimit:'50',selectedCount:'43'},
        {courseName:'体适能课',teacherName:'喻环韵',gradeName:'四年级五年级',classNum:'36',classTime:'每周四15:30-16:10',locationName:'四年级1班',totalLimit:'50',selectedCount:'43'},
        {courseName:'中文阅读',teacherName:'伍萍桂',gradeName:'五年级六年级',classNum:'26',classTime:'每周四15:30-16:10',locationName:'五年级1班',totalLimit:'50',selectedCount:'43'},
      ],
      campusList: [
        // {id:'campus1',label:'驻马店实验小学主校区'},
      ],
      gradeList: [
        {id:'g1',label:'一年级'},
				{id:'g2',label:'二年级'},
				{id:'g3',label:'三年级'},
				{id:'g4',label:'四年级'},
				{id:'g5',label:'五年级'},
				{id:'g6',label:'六年级'},
      ],
      school_info: JSON.parse(sessionStorage.getItem("classList"))||[],
    };
  },
  watch: {
    "form.campus": function (n, o) {
      this.form.gradeId = "";
      this.gradeList = [];
      this.gradeList =
        this.campusList.filter((v) => v.id === n)[0]?.children || [];
    },
  },
  mounted() {},
  created() {
    if(this.semesterArr && this.semesterArr.length>0){
        this.semesterList = this.semesterArr.map((v) => ({
          label: v.schoolYear + "年度" + (v.semester ===1?'上学期':'下学期'),
          value:v.schoolYear+'_'+v.semester,
          id: v.id,
        }));
    }
    this.getDataList();
    this.campusList = this.school_info.slice();
  },
  methods: {
    async getDataList() {
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        gradeId: this.form.gradeId,
        courseName: this.form.courseName,
        extOrgName: this.info.extOrgName,
        typeId: "",
        teacherId: "",
        orgId:sessionStorage.getItem('orgId'),
        platformCode:sessionStorage.getItem('platformCode'),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      // var { data, code } = await api.handleCourseList(params);
      // if (code == "0") {
      //   this.tableData = data.list;
      //   this.page.totalPage = data.total;
      // }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.$emit("to-index");
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 189px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
